import React, { useState } from "react"
import LayoutHeader from "../../layouts/partials/LayoutHeader"
import { Button, Layout, Typography } from "antd"
import { apiDownload } from "../../utils/Api"
import { FilePdfOutlined } from '@ant-design/icons';

export default function NYTBestsellers() {
    
    const getList = () => {
        apiDownload({}, "new_york_times/getExcel", true);
    }

    return (
        <>
            <Layout className="layout">
                <LayoutHeader
                    title="New York Times Bestsellers"
                    description={<>The below report is based on sales from the previous Sunday through Saturday.<br /><div className="shim" />
                        <Button icon={<FilePdfOutlined />} size="small" onClick={() => getList()} type="primary"><small>&nbsp;&nbsp;Download List</small></Button>
                    </>}
                />
                <Layout.Content style={{ "padding": "0px" }} >
                    <div style={{ "padding": "20px" }}>
                        <Typography.Title level={5}>Weekly Bestseller file submission guidelines</Typography.Title>
                        <Typography.Paragraph type="secondary">
                            Only new books (with ISBNs starting with <strong>978</strong> and <strong>979</strong>), and signed stock (i.e. where the 13th position of the ISBN is an <strong>S</strong>) will be included.
                        </Typography.Paragraph>
                        <Typography.Paragraph type="secondary">
                            Once you download the file, it <strong>must</strong> be uploaded on the New York Times site here <a href="https://bestsellers.nytimes.com/login" target="_blank">https://bestsellers.nytimes.com/login</a>
                        </Typography.Paragraph>
                        <Typography.Paragraph type="secondary">
                            Files should be uploaded weekly, <strong>NO LATER THAN TUESDAY, 12pm NOON EST</strong> <em>*Monday is preferred</em>
                        </Typography.Paragraph>
                    </div>
                </Layout.Content>
            </Layout>
        </>

    )
}